import React from 'react'
import styled from 'styled-components'
import { mediaMax, mediaMin } from 'frontend_core/dist/styles/media'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'
import Colors from 'components/styles/colors'

const Description = styled.p`
  margin: ${spacing.medium_2}px 0 0;
  font-size: ${fontSize.small_3}px;
  color: ${Colors.black};
  ${mediaMin.phone`
    margin: ${spacing.large}px 0 0;
  `};
`

export type PropTypes = {
  children: any,
}

export default function NoItemDescription(props: PropTypes) {
  return <Description>{props.children}</Description>
}



// WEBPACK FOOTER //
// ./src/components/atoms/NoItemDescription/index.jsx